import type { Id } from '@e-socna/data-layer';

import { useFolderAccess } from '../../../components/Access/hooks/useFolderAccess.hook';
import { useMissionAccess } from '../../../components/Access/hooks/useMissionAccess.hook';
import { allGatesOf } from '../../../components/Access/utils/access-gate.util';
import type { AccessGate } from '../../../components/Access/types/access-gate.type';

// Creating a sub-mission takes the right to create a mission in the folder, and a collaboration
// whose submitted quotation does not freeze its sub-missions.
export const useSubMissionCreationGate = (
  folderId: Id | undefined,
  collaborationId: Id | undefined,
): AccessGate =>
  allGatesOf(
    useFolderAccess(folderId).initMission,
    useMissionAccess(collaborationId).updateQuotationRelatedFields,
  );
